import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ButtonBase } from '@material-ui/core'
import styles from './SegmentedControl.module.scss'
import { isE700Device } from '../../VNAndroidSDK/Utils'

const SegmentedControlV2 = ({ items, selectedValue, onSelect, className, disabled }) => {
  return (
    <div className={classNames(className, styles.SegmentedControl, { [styles.disabled]: disabled })}>
      {items?.map((item, index) => {
        return (
          <ButtonBase
            disableRipple={isE700Device()}
            component="div"
            key={item.label + index}
            className={classNames(styles.SegmentedControl__item, {
              [styles.isSelected]: selectedValue === item.value,
            })}
            onClick={() => onSelect(item.value)}
          >
            {item.label}
          </ButtonBase>
        )
      })}
    </div>
  )
}

export default SegmentedControlV2

SegmentedControlV2.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })),
  selectedValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onSelect: PropTypes.func,
}
